// extracted by mini-css-extract-plugin
module.exports = {"custom-icon":"styles_custom-icon__2DXjO"};